import React, { useState, useEffect } from "react";
import { FaBell, FaCoins } from "react-icons/fa";
import axios from "axios";
import { useNavigate } from 'react-router-dom';
import "./navbar.css";

const Navbar = () => {
  const [coins, setCoins] = useState(0); // Store coins balance
  const [loading, setLoading] = useState(true); // Loading state
  const [error, setError] = useState(null); // Error state
  const navigate = useNavigate();


  // 🔹 Function to Fetch Balance Coins
  const fetchBalance = async () => {
    try {
        const token = localStorage.getItem("token");
        const userId = localStorage.getItem("user_id");

        if (!token || !userId) {
            console.error("❌ Token or User ID missing.");
            setError("User not authenticated.");
            setLoading(false);
            return;
        }

        const response = await axios.get(`https://backend.aubattle.com/api/coins/balance/${userId}`, {
            headers: { Authorization: `Bearer ${token}` },
        });

        console.log("✅ API Response:", response.data);
        
        // ✅ Fix: Correctly accessing `coins` instead of `balance`
        setCoins(response.data.coins);  
        setError(null);
    } catch (err) {
        console.error("❌ Error fetching coins:", err.response?.data || err.message);
        setError("fetch coins failed");
    } finally {
        setLoading(false);
    }
};


  // 🔹 Run Function on Component Mount
  useEffect(() => {
    fetchBalance(); // Component mount hone par balance fetch karo

    const interval = setInterval(() => {
        fetchBalance(); // Har 15 seconds me coins update karo
    }, 15000);

    return () => clearInterval(interval); // Component unmount hone par interval cleanup karo
}, []);


  return (
    <nav className="navbar">
      <div className="logo">
        <img src="/images/graditn_logo.png" alt="eSportsLogo" width={80} />
      </div>
      <div className="welcome">
        Welcome Back, <br /> AU Battle
      </div>
      <div className="icons">
        <div className="notification" onClick={() => navigate('/updates')}>
  <FaBell className="icon" />
</div>
        <div className="coin-container"  onClick={() => navigate('/mywallet')}>
          <FaCoins className="icon2" />
          <span className="coin-count">
            {loading ? (
              <span className="loading-text">Loading...</span>
            ) : error ? (
              <span className="error-text">{error}</span>
            ) : (
              <span className="coin-value">{coins}</span>
            )}
          </span>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
